import React, { Component } from 'react';
import { Link } from 'react-router';
import startsWith from 'lodash/startsWith';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './AdvanceList.css';

class AdvanceList extends Component {
  render() {
    const { className } = this.props;

    return (
      <ul className={classnames('AdvanceList', className)}>
        {this.props.children}
      </ul>
    );
  }
}

const propTypes = {
  linkTo: PropTypes.string,
  title: PropTypes.string,
  details: PropTypes.array,
  external: PropTypes.bool,
  onClick: PropTypes.func,
};

const defaultProps = {
  title: '',
  details: [],
  external: true,
  onClick: () => {},
};

class AdvanceListItem extends Component {
  get linkNode() {
    const {
      linkTo,
      onClick,
      title,
      details,
    } = this.props;

    return (
      <Link
        className="AdvanceListItem-link"
        to={linkTo}
        onClick={onClick}
      >
        <div className="AdvanceListItem-link-info">
          <h3 className="AdvanceListItem-link-info-heading">
            {title}
          </h3>
          {details.map((detail, i) => (
            <p
              key={i}
              className="AdvanceListItem-link-info-detail"
            >
              {detail}
            </p>
          ))}
        </div>
        <i className="AdvanceListItem-link-icon material-icons">chevron_right</i>
      </Link>
    );
  }

  get anchorNode() {
    const {
      linkTo,
      external,
      onClick,
      title,
      details,
    } = this.props;

    return (
      <a
        className="AdvanceListItem-link"
        href={linkTo}
        target={external ? '_blank' : null}
        rel={external ? 'noopener noreferrer' : null}
        onClick={onClick}
      >
        <div className="AdvanceListItem-link-info">
          <h3 className="AdvanceListItem-link-info-heading">
            {title}
          </h3>
          {details.map((detail, i) => (
            <p
              key={i}
              className="AdvanceListItem-link-info-detail"
            >
              {detail}
            </p>
          ))}
        </div>
        <i className="AdvanceListItem-link-icon material-icons">chevron_right</i>
      </a>
    );
  }

  render() {
    const { linkTo } = this.props;

    return (
      <li className="AdvanceListItem">
        {startsWith(linkTo, '/') ? this.linkNode : this.anchorNode}
      </li>
    );
  }
}

AdvanceListItem.propTypes = propTypes;
AdvanceListItem.defaultProps = defaultProps;

export { AdvanceList, AdvanceListItem };
